import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import About from "./sections/About";
import Contact from "./sections/Contact";
import ServicesOffered from "./sections/ServicesOffered";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <About />
      <ServicesOffered />
      <Contact />
      <Footer />
    </div>;
}